import script from "./Similar.vue?vue&type=script&setup=true&lang=js"
export * from "./Similar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__